import { Provider } from "@angular/core";
import { map, Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { SmartCell } from "../../models/agreement.model";
import {
  LevelResourcePlanningMapped,
  RetrievePlanningMapped,
} from "../../models/personnel.model";
import { PersonnelRepository } from "../../repositories/personnel.repository";

interface retrievePlanningUseCaseParams {
  resourceId: number;
}
export class RetrievePlanningUseCase
  implements UseCase<retrievePlanningUseCaseParams, RetrievePlanningMapped>
{
  constructor(private repo: PersonnelRepository) {}

  execute(
    param: retrievePlanningUseCaseParams,
  ): Observable<RetrievePlanningMapped> {
    return this.repo.retrieveResourcePlanning(param.resourceId).pipe(
      map((response) => {
        let obj = {
          planning: response.planning.levelResourcePlanning.map(
            (m) =>
              ({
                code: m.code,
                contractId: m.contractId,
                levelType: m.levelType,
                name: m.name,
                proposalId: m.proposalId,
                agreementId: m.smarts[0].agreementId,
                smarts: m.smarts.map(
                  (s) =>
                    ({
                      id: s.id,
                      isEdited: false,
                      scheduledHours: s.numberOfHours,
                      week: s.week,
                      weeklyContractHours: s.weeklyContractScheduledHours,
                      weeklyProposalHours: s.weeklyProposalScheduledHours,
                      weeklyTheoreticalHours: s.weeklyTheoreticalHours,
                    }) as SmartCell,
                ),
              }) as LevelResourcePlanningMapped,
          ),
          skills: response.planning.skills,
          languages: response.planning.languages,
          certifications: response.planning.certifications,
          itTools: response.planning.itTools,
          courses: response.planning.courses,
          educations: response.planning.educations,
          memberships: response.planning.memberships,
          outsideWorkExperiences: response.planning.outsideWorkExperiences,
          resource: response.planning.resource,
        };
        return obj;
      }),
    );
  }
}

const retrievePlanningUseCaseFactory = (repo: PersonnelRepository) =>
  new RetrievePlanningUseCase(repo);
export const retrievePlanningUseCaseProvider: Provider = {
  provide: RetrievePlanningUseCase,
  useFactory: retrievePlanningUseCaseFactory,
  deps: [PersonnelRepository],
};
